import { useEffectOnce } from "react-use";
import { HeroSection } from "../components";
import { useHandleGroupActionState } from "../hooks/use-handle-group-action-state";
import { useRoutes } from "../hooks/use-routes";
import { useCartStore } from "../store/use-cart-store";
import { useGetConfig } from "../store/use-config";
import { formatAddress } from "../utils/format-address";
import { formatDate } from "../utils/format-date";

export const Homepage = () => {
  const config = useGetConfig();
  const { goToCatalog } = useRoutes();
  const { reset: resetCart } = useCartStore();

  useHandleGroupActionState();

  // Intro is the start of the flow — clear any cart left over in localStorage (48h persist)
  // so the catalog doesn't open with a product already selected.
  useEffectOnce(() => {
    resetCart();
  });

  return (
    <HeroSection
      dateRange={`${formatDate(config.startsAt)} - ${formatDate(config.endsAt)}`}
      address={formatAddress(config.address)}
      onClick={goToCatalog}
    />
  );
};
